module.exports = __webpack_public_path__ + "static/img/bigbg.79b045c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigbg.png
// module id = Tfpy
// module chunks = 12